import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "flex md6" }
const _hoisted_3 = { class: "flex md6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "flex md6" }
const _hoisted_6 = { class: "flex md6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "flex md6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "px-2" }, "Endereço", -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "flex md6" }
const _hoisted_12 = { class: "flex md2" }
const _hoisted_13 = { class: "flex md4" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "flex md6" }
const _hoisted_16 = { class: "flex md6" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "flex md6" }
const _hoisted_19 = { class: "flex md3" }
const _hoisted_20 = { class: "flex md3" }
const _hoisted_21 = { class: "mdo-select" }
const _hoisted_22 = { for: "country" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "BR" }, " Brasil ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "ES" }, " Espanha ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "PT" }, " Portugal ", -1)
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "flex xs12" }
const _hoisted_29 = { class: "row mt-2" }
const _hoisted_30 = { class: "flex md6" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "flex md12" }
const _hoisted_33 = { class: "mdo-select" }
const _hoisted_34 = { for: "type" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "flex md12" }
const _hoisted_38 = { class: "flex md6" }

import {
  AccountConfigsInput,
  AddressInput,
  MyAccountUpdateInput,
  PromotionConfigInput,
  PromotionTypeEnum, User
} from "@/codes/gen/types";
import { AccountService } from "@/codes/services/AccountService";
import { ReactiveData } from "@/codes/types/MDOTypes";
import { ROUTE_NAMES } from "@/codes/util/constants";
import { Confirm } from "@/codes/util/swalUtil";
import router from "@/router";
import { useForm } from "vee-validate";
import { onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const myUserInfos = reactive<ReactiveData<User|null>>({data: null});

const account = reactive<ReactiveData<MyAccountUpdateInput>>({
    data: {
      address: {} as AddressInput
    } as MyAccountUpdateInput
  });

const configs = reactive<ReactiveData<AccountConfigsInput>>({
  data: {
      promotion: {
        enable: false
      } as PromotionConfigInput
    } as AccountConfigsInput
});
let configsDatabase: AccountConfigsInput = {};

const form = useForm();

const formMeta = form.meta;

const i18n = useI18n();

const types = reactive({ data: [] as any });
// types.data.push({ text: i18n.t('register.none'), value: 0 });
for (const a of Object.values(PromotionTypeEnum)) {
  const t = i18n.t(`enums.${a}`);
  types.data.push({ text: t, value: a });
}

const loadMyAccount = async function() {
  const service = new AccountService();
  const result = await service.getMyAccount();
  if (result?.sessionAccount) {
    const ac: MyAccountUpdateInput = {
      cnpj: result.sessionAccount.cnpj,
      email: result.sessionAccount.email,
      name: result.sessionAccount.name,
      phone: result.sessionAccount.phone,
      whatsapp: result.sessionAccount.whatsapp,
      address: {} as AddressInput,
    };
    if (result.sessionAccount.address) {
      ac.address = {
        city: result.sessionAccount.address.city,
        complement: result.sessionAccount.address.complement,
        country: result.sessionAccount.address.country,
        district: result.sessionAccount.address.district,
        number: result.sessionAccount.address.number,
        postcode: result.sessionAccount.address.postcode,
        state: result.sessionAccount.address.state,
        street: result.sessionAccount.address.street,
      };
    }

    if (result.sessionAccount.configs) {
      if (result.sessionAccount.configs.promotion) {
        configs.data.promotion = {
          enable: result.sessionAccount.configs.promotion.enable,
          type: result.sessionAccount.configs.promotion.type,
          value: result.sessionAccount.configs.promotion.value
        }
      }
      configsDatabase = result.sessionAccount.configs;
    }

    account.data = ac;
    myUserInfos.data = {...result};
    form.setValues(ac);
  }
}

const save = async function() {
  const validate = await form.validate() as any;
  if (validate.valid) {
    const service = new AccountService();

    if (configs.data.promotion?.enable) {
      account.data.configs = configs.data;
    } else if (configsDatabase.promotion !== null && configsDatabase.promotion?.enable) {
      account.data.configs = {
        promotion: {
          enable: false,
          type: configsDatabase.promotion.type,
          value: configsDatabase.promotion.value
        }
      }
    }

    const result = await service.updateMyAccount(account.data);
    if (result && result.data.id) {
      router.push({ name: ROUTE_NAMES.home });
    }
  }
}

const cancel = function() {
  if (form.meta.value.dirty) {
    Confirm.fire({
      title: i18n.t('form.confirmCancelTitle'),
      text: i18n.t('form.confirmCancelText')
    })
    .then((result) => {
      if (result.isConfirmed) {
        router.push({ name: ROUTE_NAMES.home });
      }
    });
  } else {
    router.push({ name: ROUTE_NAMES.home });
  }
}

onMounted(() => {
  loadMyAccount();
})


return (_ctx: any,_cache: any) => {
  const _component_va_alert = _resolveComponent("va-alert")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_VField = _resolveComponent("VField")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_va_switch = _resolveComponent("va-switch")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_form, {
      "form-meta": _unref(formMeta),
      onSave: save,
      onCancel: cancel
    }, {
      default: _withCtx(() => [
        (_unref(myUserInfos).data?.deletedAt)
          ? (_openBlock(), _createBlock(_component_va_alert, {
              key: 0,
              color: "warning",
              closeable: "",
              title: "USUÁRIO/A INATIVO/A",
              icon: "warning",
              center: "",
              class: "mb-6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, "Este usuário/a foi desativado/a em " + _toDisplayString(_unref(myUserInfos).data.deletedAt?.transform) + ".", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(myUserInfos).data?.sessionAccount?.deletedAt)
          ? (_openBlock(), _createBlock(_component_va_alert, {
              key: 1,
              color: "warning",
              closeable: "",
              title: "CONTA INATIVA",
              icon: "warning",
              center: "",
              class: "mb-6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, "Esta conta foi desativada em " + _toDisplayString(_unref(myUserInfos).data.sessionAccount.deletedAt?.transform) + ". Ela precisa ser reativada para voltar a utilizá-la.", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_VField, {
              name: "name",
              rules: 'required|min:3'
            }, {
              default: _withCtx(({ field, errors: nameErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(account).data.name = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.name'),
                  error: nameErrors && nameErrors.length > 0,
                  "error-messages": nameErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VField, {
              name: "cnpj",
              rules: 'required|min:14'
            }, {
              default: _withCtx(({ field, errors: cnpjError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.cnpj,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(account).data.cnpj = $event)),
                  class: "mb-4",
                  label: _ctx.$t('account.cnpj'),
                  error: cnpjError && cnpjError.length > 0,
                  "error-messages": cnpjError,
                  mask: { numericOnly: true, delimiters: [ '.', '.', '/', '-' ], blocks: [2, 3, 3, 4, 2] }
                }), null, 16, ["modelValue", "label", "error", "error-messages", "mask"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_VField, {
              name: "email",
              rules: 'email'
            }, {
              default: _withCtx(({ field, errors: emailError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(account).data.email = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.email'),
                  error: emailError && emailError.length > 0,
                  "error-messages": emailError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_VField, {
              name: "phone",
              rules:  _unref(account).data.address?.country === 'PT' ? 'min:10' : 'min:9' 
            }, {
              default: _withCtx(({ field, errors: phoneError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(account).data.phone = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.phone'),
                  error: phoneError && phoneError.length > 0,
                  "error-messages": phoneError,
                  messages: "Ex: +5544988776655, +34999999999 ou +351987654321"
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            }, 8, ["rules"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_VField, {
              name: "whatsapp",
              rules:  _unref(account).data.address?.country === 'PT' ? 'min:10' : 'min:9' 
            }, {
              default: _withCtx(({ field, errors: whatsappErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.whatsapp,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(account).data.whatsapp = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.whatsapp'),
                  error: whatsappErrors && whatsappErrors.length > 0,
                  "error-messages": whatsappErrors,
                  messages: "Ex: +5544988776655, +34999999999 ou +351987654321"
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            }, 8, ["rules"])
          ])
        ]),
        _createVNode(_component_va_divider, { orientation: "left" }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_VField, {
              name: "street",
              rules: 'min:6'
            }, {
              default: _withCtx(({ field, errors: streetErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.street,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(account).data.address.street = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.street'),
                  error: streetErrors && streetErrors.length > 0,
                  "error-messages": streetErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_VField, { name: "number" }, {
              default: _withCtx(({ field, errors: numberErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.number,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_unref(account).data.address.number = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.number'),
                  error: numberErrors && numberErrors.length > 0,
                  "error-messages": numberErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_VField, {
              name: "postcode",
              rules: 'min:8'
            }, {
              default: _withCtx(({ field, errors: postcodeErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.postcode,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_unref(account).data.address.postcode = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.postcode'),
                  error: postcodeErrors && postcodeErrors.length > 0,
                  "error-messages": postcodeErrors,
                  mask: { numericOnly: true, delimiter: '-', blocks: [5, 3] }
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_VField, {
              name: "district",
              rules: 'min:6'
            }, {
              default: _withCtx(({ field, errors: districtErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.district,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_unref(account).data.address.district = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.district'),
                  error: districtErrors && districtErrors.length > 0,
                  "error-messages": districtErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_VField, {
              name: "complement",
              rules: 'min:6'
            }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.complement,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_unref(account).data.address.complement = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.complement')
                }), null, 16, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_ErrorMessage, { name: "complement" })
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_VField, {
              name: "city",
              rules: 'min:3'
            }, {
              default: _withCtx(({ field, errors: cityErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.city,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_unref(account).data.address.city = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.city'),
                  error: cityErrors && cityErrors.length > 0,
                  "error-messages": cityErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_VField, {
              name: "state",
              rules: 'min:2'
            }, {
              default: _withCtx(({ field, errors: stateErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(account).data.address.state,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_unref(account).data.address.state = $event)),
                  class: "mb-4",
                  label: _ctx.$t('address.state'),
                  error: stateErrors && stateErrors.length > 0,
                  "error-messages": stateErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('address.country')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_unref(account).data.address.country = $event)),
                name: "country"
              }, _hoisted_26, 512), [
                [_vModelSelect, _unref(account).data.address.country]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_va_collapse, {
              header: _ctx.$t('myAccount.configs.promotion.header')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_card_content, { style: {"background-color":"var(--va-collapse-header-content-background-color)"} }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('myAccount.configs.promotion.type')), 1),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_unref(configs).data.promotion.type = $event)),
                                    name: "type"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(types).data, (op) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: op.value,
                                        value: op.value
                                      }, _toDisplayString(op.text), 9, _hoisted_35))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _unref(configs).data.promotion.type]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_component_VField, { name: "type" }, {
                                  default: _withCtx(({ field}) => [
                                    _createVNode(_component_va_switch, _mergeProps(field, {
                                      modelValue: _unref(configs).data.promotion.enable,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_unref(configs).data.promotion.enable = $event)),
                                      "true-inner-label": _ctx.$t('form.enabled'),
                                      "false-inner-label": _ctx.$t('form.disabled'),
                                      class: "mr-4"
                                    }), null, 16, ["modelValue", "true-inner-label", "false-inner-label"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_VField, {
                              name: "configs.promotion.value",
                              rules: { required : _unref(configs).data.promotion.enable, min:3 }
                            }, {
                              default: _withCtx(({ field, errors: promValueErrors }) => [
                                _createVNode(_component_va_input, _mergeProps(field, {
                                  modelValue: _unref(configs).data.promotion.value,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_unref(configs).data.promotion.value = $event)),
                                  class: "mb-4 prom-value",
                                  type: "textarea",
                                  outline: "",
                                  label: _ctx.$t('myAccount.configs.promotion.value'),
                                  error: promValueErrors && promValueErrors.length > 0,
                                  "error-messages": promValueErrors
                                }), null, 16, ["modelValue", "label", "error", "error-messages"])
                              ]),
                              _: 1
                            }, 8, ["rules"])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["header"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["form-meta"])
  ]))
}
}

})